import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

// --- Rafraîchissement automatique de la session ---
// L'access_token expire au bout d'1 h. Quand une requête renvoie 401, on tente
// UN appel à /auth/refresh (via le refresh_token, valable 7 jours) puis on rejoue
// la requête d'origine. L'utilisateur reste ainsi connecté (clic sur le logo,
// fermeture/réouverture d'onglet…) tant que le refresh_token est valide.
const AUTH_SKIP = ["/auth/login", "/auth/refresh", "/auth/logout", "/auth/register"];
let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { response, config } = error;
    if (!response || response.status !== 401 || !config || config._retry) {
      return Promise.reject(error);
    }
    const url = config.url || "";
    if (AUTH_SKIP.some((p) => url.includes(p))) {
      return Promise.reject(error);
    }
    config._retry = true;
    try {
      // Un seul /auth/refresh partagé même si plusieurs requêtes échouent en même temps.
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh").finally(() => { refreshPromise = null; });
      }
      await refreshPromise;
      return api(config); // rejoue la requête d'origine avec le nouveau cookie
    } catch (e) {
      return Promise.reject(error);
    }
  }
);

export function apiError(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const STATUS_LABELS = {
  nouveau: "Nouveau",
  a_qualifier: "À qualifier",
  envoye: "Envoyé",
  attente_confirmation: "En attente confirmation",
  confirme: "Confirmé",
  rejete: "Rejeté",
  arbitrage: "À arbitrer",
};

export const STATUS_CLASSES = {
  nouveau: "bg-blue-50 text-blue-700 border-blue-200",
  a_qualifier: "bg-sky-50 text-sky-700 border-sky-200",
  envoye: "bg-violet-50 text-violet-700 border-violet-200",
  attente_confirmation: "bg-amber-50 text-amber-700 border-amber-200",
  confirme: "bg-emerald-50 text-emerald-700 border-emerald-200",
  rejete: "bg-red-50 text-red-700 border-red-200",
  arbitrage: "bg-orange-50 text-orange-700 border-orange-200",
};
